import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

import { Actions, ActionTypes } from '../../store/recipes/recipes.actions';
import { StateInterface } from '../../store/state.model';
import { FilterInterface } from '../../store/filter/filter.models';
import { HeadersHelper, ItemsHelper, RecipesHelper } from '../../helpers';
import { _, getState, tassign, Moment } from '../../tools';

import 'rxjs/Rx';

@Injectable()

/**
 * Class representing the Recipes service.
 */
export class RecipesService {

	/**
	 * Constructor.
	 * @param {string} apiEndPoint
	 * @param {Http} http
	 * @param {Store} store
	 * @return {void}
	 */
	constructor(
		@Inject('ApiEndpoint') private apiEndpoint: string,
		private http: Http,
		private store: Store<StateInterface>) {
	}

	/**
	 * Retrieve recipes data from server and dispatch action
	 * to update the store accordingly.
	 * @param  {number} - cabinetID [description]
	 * @return {Observable}
	 */
	hydrateRecipes(cabinetID?: number): Observable<Response> {
		this.store.dispatch(this.setIsLoading(true));
		let url: string = `${this.apiEndpoint}recipe/available`;
		if (cabinetID) {
			url += `/` + cabinetID;
		}
		return this.http.get(url, HeadersHelper.getOptions(this.store));
	}

	/**
	 * Dispatch an action to load recipes.
	 * @param {object} result
	 * @return {Actions}
	 */
	loadRecipes(result: any): Actions {
		const { recipes } = getState(this.store);

		return {
			type: ActionTypes.LOAD_RECIPES,
			payload: tassign(recipes, {
				items: ItemsHelper.mapRecipeItems(result),
				lastUpdated: Moment().unix(),
				isLoading: false
			})
		};
	}

	/**
	 * Hydrates recipes by date and location which will increase performance.
	 * @param {string} date - Date to fetch the date for.
	 * @param {number} locationId - Location to fetch the date for.
	 * @return {Observable}
	 */
	hydrateRecipesByDateAndLocation(date: string, locationId: number): Observable<Response> {
		this.store.dispatch(this.setIsLoading(true));
		let url: string = `${this.apiEndpoint}recipe/available/filter/${date}/${locationId}`;
		return this.http.get(url, HeadersHelper.getOptions(this.store));
	}

	/**
	 * Process recipes.
	 * @param {string} date
	 * @param  {any} data
	 * @return {Actions}
	 */
	processRecipes(date: string, items: any): Actions {
		const newItems = ItemsHelper.mapRecipeItems(items);

		return {
			type: ActionTypes.ADD_AVAILABILITY,
			payload: {
				date: date,
				items: newItems,
			}
		};
	}

	/**
	 * Filters recipies
	 * @param {FilterInterface} filter
	 * @return {Actions}
	 */
	filteredRecipes(recipes): Actions {
		return {
			type: ActionTypes.SET_FILTERED_RECIPES,
			payload: recipes,
		};
	}

	/**
	 * Dispatch an action to reset the entire state.
	 * @return {Actions}
	 */
	resetState(): Actions {
		return {
			type: ActionTypes.RESET_STATE
		};
	}

	/**
	 * Dispatch an action to change the state for 'selected'.
	 * @param {null|number} to - The new state
	 * @return {Actions}
	 */
	setSelected(to: null | number): Actions {
		return {
			type: ActionTypes.SET_SELECTED,
			payload: to
		};
	}

	/**
	 * Dispatch an action to change the state for 'lastUpdated'.
	 * @param {number} timeStamp - The new state
	 * @return {Actions}
	 * @todo unit test
	 */
	setLastUpdated(timeStamp: number | null): Actions {
		return {
			type: ActionTypes.SET_LAST_UPDATED,
			payload: timeStamp
		};
	}

	/**
	 * Dispatch an action to change the state for 'isLoading'.
	 * @param {boolean} to - The new state
	 * @return {Actions}
	 */
	setIsLoading(to: boolean): Actions {
		return {
			type: ActionTypes.SET_IS_LOADING,
			payload: to
		};
	}
}
